module.exports = __webpack_public_path__ + "img/integration.ed999ada.png";